exports.components = {
  "component---src-pages-2025-js": () => import("./../../../src/pages/2025.js" /* webpackChunkName: "component---src-pages-2025-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-conduct-js": () => import("./../../../src/pages/conduct.js" /* webpackChunkName: "component---src-pages-conduct-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-sponsor-js": () => import("./../../../src/pages/sponsor.js" /* webpackChunkName: "component---src-pages-sponsor-js" */)
}

